const { useImperativeHandle, useState, forwardRef } = require('react');

const { useI18n } = require('nordic/i18n');

const ModalZipcodeV2 = require('../../ModalZipcodeV2');
const { useShippingData } = require('./useShippingData');

const ModalZipcode = ({ onSelectZipcode }, ref) => {
  const { i18n } = useI18n();
  const [modalOpened, setModalOpened] = useState(false);
  const { data: { countryId, deviceType } } = useShippingData();

  useImperativeHandle(ref, () => ({
    openModal: () => setModalOpened(true),
  }));

  return (
    <ModalZipcodeV2
      deviceType={deviceType}
      i18n={i18n}
      open={modalOpened}
      setOpen={setModalOpened}
      populateFields={(currentStateCB) => {
        const { zipcode } = currentStateCB();
        onSelectZipcode({ zipcode })
      }}
      countryId={countryId}
    />
  );
};

module.exports = {
  ModalZipcode: forwardRef(ModalZipcode),
};
